import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { openWhatsApp, websitePhoneLabel, WEBSITE_PHONE_DEFAULT } from "@/lib/whatsapp";

export default function ContactCTA({ settings }) {
  const { lang, t } = useLang();
  const hasMedia = settings?.ctaMediaUrl && settings?.ctaMediaType;
  const isVideo = settings?.ctaMediaType === "video";

  return (
    <section className="bg-[#0C0C0C] py-24 md:py-32 border-t border-[#2A2A2A]" data-testid="contact-cta-section">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        {hasMedia && (
          <div className="mb-12 md:mb-16 overflow-hidden border border-[#2A2A2A]" data-testid="cta-media">
            {isVideo ? (
              <video
                src={settings.ctaMediaUrl}
                poster={settings.ctaMediaPoster || undefined}
                autoPlay muted loop playsInline
                className="w-full h-auto max-h-[60vh] object-cover" />
            ) : (
              <img src={settings.ctaMediaUrl} alt="" className="w-full h-auto max-h-[60vh] object-cover" />
            )}
          </div>
        )}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}>
          <div className="text-overline text-[#C9A55A] mb-5">{t.contact.kicker}</div>
          <h2 className="font-display text-[#F5F1EB] text-3xl md:text-5xl">{t.contact.title}</h2>
          <p className="mt-6 text-[#F5F1EB]/70 font-light max-w-xl mx-auto">{t.contact.subtitle}</p>
          <button onClick={() => openWhatsApp(t.whatsapp.generic, settings, lang)} className="btn-red mt-10" data-testid="contact-cta-whatsapp">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.34 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24z"/>
            </svg>
            {t.contact.cta}
          </button>
          <div className="mt-6 text-xs text-[#8A8A8A] tracking-[0.2em] uppercase">{websitePhoneLabel(settings) || WEBSITE_PHONE_DEFAULT}</div>
        </motion.div>
      </div>
    </section>
  );
}
